// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#1d3b65", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#014e7b", // Primary -> Light
        dark: "#010000", // Primary -> Dark
    },
    secondary: {
        main: "#5387b5", // Secondary -> Main
        contrast: "#ffffff", // None, look at secondary button text color
        light: "#73a6d3", // Secondary -> Light
        dark: "#3a70a0", // Secondary -> Dark
    },
    tertiary: {
        main: "#657883", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#c0cfdd", // Tertiary -> Light
        dark: "#010000", // Tertiary -> Dark
    },
    common: {
        border: "#adadac", // Black & White -> Border
        borderLight: "#d6d6d6", // Black & White -> Border Light
        borderDark: "#6F7175", // Gray Shades -> Main
        accent: "#f4f4f4", // Gray Shades -> Light
        accentContrast: "#272c37", // Text Color -> Main
        accentContrastLight: "#6F7175", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#272c37", // Text Color -> Main
        disabled: "#f4f4f4", // Gray Shades -> Light
        disabledDark: "#c9cacd", // Gray Shades -> Mid
    },
    text: {
        main: "#272c37", // Text Color -> Main
        accent: "#93959b", // Text Color -> Accent
        disabled: "#8f8f8f", // Gray Shades -> Main
        link: "#014e7b", // Primary -> Main
        linkHover: "#010000", // Primary -> Dark
        linkAlt: "#272c37", // Text Color -> Main
        linkAltHover: "#014e7b", // Primary -> Main
        input: "#272c37", // Text Color -> Main
    },
    success: {
        main: "#007832", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#ddefe2", // Alerts/Light -> Success
    },
    warning: {
        main: "#ae4d00", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#ffe7c8", // Alerts/Light -> Warning
    },
    danger: {
        main: "#bc1e2b", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#ffe9ef", // Alerts/Light -> Error
    },
    info: {
        main: "#1875af", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#e9f8ff", // Alerts/Light -> Info
    },
    neutral: {
        main: "#666666", // None
        contrast: "#ffffff", // None
        light: "#e0e0e0", // None
    },
    invert: {
        main: "#ffffff",
        contrast: "#014e7b",
        dark: "#010000",
    },
    placeholder: {
        main: "#666666", // None, look at header search field text color
        disabled: "#8f8f8f", // Text Color -> Disabled
    },
    button: {
        disabled: {
            // These colors should be different than the field disabled styles (common.disabled / text.disabled)
            main: "#c9cacd", // None
            contrast: "", // None
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#272c37", // Text Color -> Main
        hover: "#010000", // Primary -> Dark
        accent: "#1d3b65", // Primary -> Main
        accentHover: "#010000", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#272c37", // Text Color -> Main
            hover: "#1d3b65", // Primary -> Main
            accent: "#1d3b65", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#1d3b65", // Primary -> Main
            border: "#adadac", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "#1d3b65", // Primary -> Main
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
        },
    },
    footer: {
        main: "#f4f4f4", // Gray Shades -> Light
        contrast: "#272c37", // Text Color -> Main
        alt: "#1d3b65", // Primary -> Main
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#adadac", // Black & White -> Border
        contrast: "#272c37", // Text Color -> Main
        hover: "#1d3b65", // Primary -> Main
        selected: "#1d3b65", // Primary -> Main
        selectedHover: "#010000", // Primary -> Dark
    },
};

export default colors;
